export default __webpack_public_path__ + "static/media/julian_l.db057c1e.jpg";